// APIs
import _franchiseSummaryApi from '../_api/';

// Format
import baseFormat from '../../../plugins/baseFormat';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    completedDeliveriesCount: 0,
    completedDeliveriesValue: 0,
    completedDeliveriesPercentage: 0,
    canceledDeliveriesPercentage: 0,
    onlineOrdersPercentage: 0,
    offlineOrdersPercentage: 0,
    completedOnlineOrdersPercentage: 0,
    canceledOnlineOrdersPercentage: 0,
    completedOfflineOrdersPercentage: 0,
    canceledOfflineOrdersPercentage: 0,
    storesCount: 0,
    publishedStoresCount: 0,
    activeStoresCount: 0,
    driversCount: 0,
    activeDriversCount: 0,
  },
  // -----------------------------------------------------------------
  getters: {
    completedDeliveriesCount: (state,) => state.completedDeliveriesCount,
    completedDeliveriesValue: (state,) => state.completedDeliveriesValue,
    completedDeliveriesPrice: (state,) => baseFormat.float(
      state.completedDeliveriesValue,
    ),
    completedDeliveriesPercentage: (state,) => baseFormat.
      percentage(state.completedDeliveriesPercentage,),
    canceledDeliveriesPercentage: (state,) => baseFormat.
      percentage(state.canceledDeliveriesPercentage,),
    onlineOrdersPercentage: (state,) => baseFormat.
      percentage(state.onlineOrdersPercentage,),
    offlineOrdersPercentage: (state,) => baseFormat.
      percentage(state.offlineOrdersPercentage,),
    completedDeliveriesFloat: (state,) => baseFormat.
      floatUS(state.completedDeliveriesPercentage,),
    canceledDeliveriesFloat: (state,) => baseFormat.
      floatUS(state.canceledDeliveriesPercentage,),
    onlineOrdersFloat: (state,) => baseFormat.floatUS(state.onlineOrdersPercentage,),
    offlineOrdersFloat: (state,) => baseFormat.floatUS(state.offlineOrdersPercentage,),
    completedOnlineOrdersPercentage: (state,) => baseFormat.
      percentage(state.completedOnlineOrdersPercentage,),
    canceledOnlineOrdersPercentage: (state,) => baseFormat.
      percentage(state.canceledOnlineOrdersPercentage,),
    completedOfflineOrdersPercentage: (state,) => baseFormat.
      percentage(state.completedOfflineOrdersPercentage,),
    canceledOfflineOrdersPercentage: (state,) => baseFormat.
      percentage(state.canceledOfflineOrdersPercentage,),
    completedOnlineOrdersFloat: (state,) => baseFormat.
      floatUS(state.completedOnlineOrdersPercentage,),
    canceledOnlineOrdersFloat: (state,) => baseFormat.
      floatUS(state.canceledOnlineOrdersPercentage,),
    completedOfflineOrdersFloat: (state,) => baseFormat.
      floatUS(state.completedOfflineOrdersPercentage,),
    canceledOfflineOrdersFloat: (state,) => baseFormat.
      floatUS(state.canceledOfflineOrdersPercentage,),
    storesCount: (state,) => state.storesCount,
    publishedStoresCount: (state,) => state.publishedStoresCount,
    activeStoresCount: (state,) => state.activeStoresCount,
    driversCount: (state,) => state.driversCount,
    activeDriversCount: (state,) => state.activeDriversCount,
  },
  // -----------------------------------------------------------------
  mutations: {
    setCompletedDeliveriesCount: (state, completedDeliveriesCount,) =>
      (state.completedDeliveriesCount = completedDeliveriesCount),
    setCompletedDeliveriesValue: (state, completedDeliveriesValue,) =>
      (state.completedDeliveriesValue = completedDeliveriesValue),
    setCompletedDeliveriesPercentage: (state, completedDeliveriesPercentage,) =>
      (state.completedDeliveriesPercentage = completedDeliveriesPercentage),
    setCanceledDeliveriesPercentage: (state, canceledDeliveriesPercentage,) =>
      (state.canceledDeliveriesPercentage = canceledDeliveriesPercentage),
    setOnlineOrdersPercentage: (state, onlineOrdersPercentage,) =>
      (state.onlineOrdersPercentage = onlineOrdersPercentage),
    setOfflineOrdersPercentage: (state, offlineOrdersPercentage,) =>
      (state.offlineOrdersPercentage = offlineOrdersPercentage),
    setCompletedOnlineOrdersPercentage: (state, completedOnlineOrdersPercentage,) =>
      (state.completedOnlineOrdersPercentage = completedOnlineOrdersPercentage),
    setCanceledOnlineOrdersPercentage: (state, canceledOnlineOrdersPercentage,) =>
      (state.canceledOnlineOrdersPercentage = canceledOnlineOrdersPercentage),
    setCompletedOfflineOrdersPercentage: (state, completedOfflineOrdersPercentage,) =>
      (state.completedOfflineOrdersPercentage = completedOfflineOrdersPercentage),
    setCanceledOfflineOrdersPercentage: (state, canceledOfflineOrdersPercentage,) =>
      (state.canceledOfflineOrdersPercentage = canceledOfflineOrdersPercentage),
    setStoresCount: (state, storesCount,) =>
      (state.storesCount = storesCount),
    setPublishedStoresCount: (state, publishedStoresCount,) =>
      (state.publishedStoresCount = publishedStoresCount),
    setActiveStoresCount: (state, activeStoresCount,) =>
      (state.activeStoresCount = activeStoresCount),
    setDriversCount: (state, driversCount,) =>
      (state.driversCount = driversCount),
    setActiveDriversCount: (state, activeDriversCount,) =>
      (state.activeDriversCount = activeDriversCount),
  },
  // -----------------------------------------------------------------
  actions: {
    getIndicators: ({ commit, }, { begin_date, end_date, },) => {
      return _franchiseSummaryApi.
        getIndicators({ begin_date, end_date, },).then((response,) => {
          commit('franchiseSummary/setStoresCount', response.data.stores_registered, { root: true, },);
          commit('franchiseSummary/setPublishedStoresCount', response.data.stores_published, { root: true, },);
          commit('franchiseSummary/setActiveStoresCount', response.data.stores_active, { root: true, },);
          commit('franchiseSummary/setDriversCount', response.data.drivers_count, { root: true, },);
          commit('franchiseSummary/setActiveDriversCount', response.data.drivers_active, { root: true, },);
          commit('franchiseSummary/setCompletedDeliveriesCount', response.data.orders_volume, { root: true, },);
          commit('franchiseSummary/setCompletedDeliveriesValue', response.data.orders_value, { root: true, },);
          commit('franchiseSummary/setCompletedDeliveriesPercentage', response.data.orders_completed.percentage, { root: true, },);
          commit('franchiseSummary/setCanceledDeliveriesPercentage', response.data.orders_canceled.percentage, { root: true, },);
          commit('franchiseSummary/setOnlineOrdersPercentage', response.data.orders_online, { root: true, },);
          commit('franchiseSummary/setOfflineOrdersPercentage', response.data.orders_offline, { root: true, },);
          commit('franchiseSummary/setCompletedOnlineOrdersPercentage', response.data.orders_completed.online, { root: true, },);
          commit('franchiseSummary/setCanceledOnlineOrdersPercentage', response.data.orders_canceled.online, { root: true, },);
          commit('franchiseSummary/setCompletedOfflineOrdersPercentage', response.data.orders_completed.offline, { root: true, },);
          commit('franchiseSummary/setCanceledOfflineOrdersPercentage', response.data.orders_canceled.offline, { root: true, },);
          return { ...response.data, };
        },);
    },
  },
};
